import React from "react";
import styles from "./profile.module.scss";

type Props = {
  birthplace?: string;
  height?: string;
  weight?: string;
  hobby?: string;
};
export const Profile: React.FC<Props> = (props) => {
  const { birthplace, height, weight, hobby } = props;

  return (
    <div className={styles["c-profile__wrapper"]}>
      <dl className={styles["c-profile"]}>
        <dt className={styles["c-profile__ttl"]}>身長</dt>
        <dd className={styles["c-profile__text"]} data-testid="height-dd">
          {height ? <>{height}cm</> : <>---</>}
        </dd>

        <dt className={styles["c-profile__ttl"]}>体重</dt>
        <dd className={styles["c-profile__text"]} data-testid="weight-dd">
          {weight ? <>{weight}kg</> : <>---</>}
        </dd>

        <dt className={styles["c-profile__ttl"]}>出身</dt>
        <dd className={styles["c-profile__text"]}>
          {birthplace ? <>{birthplace}</> : <>---</>}
        </dd>

        <dt className={styles["c-profile__ttl"]}>趣味</dt>
        <dd className={styles["c-profile__text"]}>
          {hobby ? <>{hobby}</> : <>---</>}
        </dd>
      </dl>
    </div>
  );
};

export default Profile;
